'use strict';

module.exports = spr;

function spr () {
  console.error('SPR (symmetric packed rank 1 operation A := alpha*x*y\' + A) not yet implemented');
}
